<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="评论内容">
                <el-input v-model="formInline.forumMsgContnet" placeholder="评论内容" style="width:220px"></el-input>
            </el-form-item>
            <el-form-item label="开始日期">
            <el-date-picker
                    v-model="formInline.startCreateTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="不选择默认查询当天">
            </el-date-picker>
            </el-form-item>
            <el-form-item label="结束日期">
            <el-date-picker
                    v-model="formInline.endCreateTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择结束日期">
            </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="returnHistory">返回</el-button>
                <el-button type="success" @click="handCrowdFundingForumList">查询</el-button>
                <el-button-group>
                    <el-button type="primary" size="mini" @click="handleCrowdSucc()">成功发券</el-button>
                    <el-button type="primary" size="mini" @click="handleCrowdFail()">失败退款</el-button>
                    <el-button type="primary" size="mini" @click="handleExpireCompensate()">过期补券</el-button>
                    <el-button type="primary" size="mini" @click="handleSoldOutCompensate()">售罄补券</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>

        <el-table
                :data="crowdFundingForumList" style="GCONFIG.styleTableSize"
                row-key="id" border v-loading="loading" stripe
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column prop="id" label="评论id" v-if='show'></el-table-column>
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="createTime" label="创建日期" width="180"></el-table-column>
            <el-table-column prop="nickName" label="用户昵称" width="120"></el-table-column>
<!--            <el-table-column prop="forumMsgType" :formatter="forumMsgTypeName" label="评论类型" width="100"></el-table-column>-->
            <el-table-column prop="forumMsgContnet" label="评论内容" width="540"></el-table-column>
            <el-table-column prop="status" :formatter="statusName" label="状态" width="120"></el-table-column>
            <el-table-column prop="forumLikeCount" label="点赞数" width="90"></el-table-column>

            <el-table-column prop="remark" label="操作" width="160">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" @click="handDeleteForum(scope.row)">删除评论</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {getCrowdFundingForumList,deleteForum,crowdSucc,crowdFail,crowdExpireCompensate,crowdSoldOutCompensate} from '../../api/api';
    export default {
        data() {
            return {
                activeNo:"",
                crowdId:"",
                proName:"",
                formInline: {
                    "forumMsgContnet":"",
                    "startCreateTime":"",
                    "endCreateTime":"",
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                showDialog: false,
                loading: true,
                crowdFundingForumList: []// 列表
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.activeNo = this.$route.query.activeNo;
            this.crowdId = this.$route.query.crowdId;
            this.proName = this.$route.query.proName;
            this.handCrowdFundingForumList();
        },
        methods: {
            handCrowdFundingForumList(){
                this.loading = true;
                this.formInline.activeNo = this.activeNo;
                this.formInline.crowdId = this.crowdId;
                getCrowdFundingForumList(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.crowdFundingForumList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handDeleteForum(row){
                this.$confirm('删除此数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteForum({id:row.id}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.handCrowdFundingForumList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.handCrowdFundingForumList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.handCrowdFundingForumList();
            },

            statusName(row, column, cellValue) {
                if (row.status == 1) {
                  return "有效";
                } else if (row.status == 2) {
                  return "删除";
                }else {
                  return "未知";
                }
            },

            //状态格式化
            forumMsgTypeName(row, column, cellValue) {
                if (row.forumMsgType == 1) {
                    return "发表";
                } else if (row.forumMsgType == 2) {
                    return "回复";
                }else {
                    return "未知";
                }
            },
            handleCrowdSucc(){
                this.$confirm('操作后不可撤回, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    crowdSucc({crowdId:this.crowdId}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            handleCrowdFail(){
                this.$confirm('操作后不可撤回, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    crowdFail({crowdId:this.crowdId}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            handleExpireCompensate(){
                this.$confirm('操作后不可撤回, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    crowdExpireCompensate({crowdId:this.crowdId}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            handleSoldOutCompensate(){
                this.$confirm('操作后不可撤回, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    crowdSoldOutCompensate({crowdId:this.crowdId}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style scoped>
    .order-main-num{
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/views/crowd/crowdFundingForumList.vue